import { ApiSuccess } from "ui/Scripts/source/models/common/apiSuccess";
import { DocumentList } from "../document/documentList";
import { postApiCall, getApiCall, getFileApiCall } from "./tokenService";
import { DocumentView } from "../document/documentView";

export const getDocumentList = (folderId: string, companyId: string, page: number, filter: string, sortColumn: string, sortOrderIsAsc: boolean): Promise<DocumentList> => {
    return getApiCall("api/document?id=" + (folderId ?? "") +
        "&companyId=" + (companyId ?? "") +
        "&page=" + page +
        "&filter=" + (filter ?? "") +
        "&sortColumn=" + (sortColumn ?? "") +
        "&sortOrderIsAsc=" + (sortOrderIsAsc ? "true" : "false"), DocumentList);
};

export const searchDocuments = (folderId: string, companyId: string, page: number, filter: string, sortColumn: string, sortOrderIsAsc: boolean): Promise<DocumentList> => {
    return getApiCall("api/document/search?id=" + (folderId ?? "") +
        "&companyId=" + (companyId ?? "") +
        "&page=" + page +
        "&filter=" + (filter ?? "") +
        "&sortColumn=" + (sortColumn ?? "") +
        "&sortOrderIsAsc=" + (sortOrderIsAsc ? "true" : "false"), DocumentList);
};

export const downloadDocument = (id: string, companyId: string): Promise<string> => {
    return getFileApiCall("api/document/download?id=" + id + "&companyId=" + companyId);
};

export const addFiles = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/document/addfiles", ApiSuccess, JSON.stringify(obj));
};

export const addFolderToFavorites = (id: string, companyId: string): Promise<ApiSuccess> => {
    return postApiCall("api/document/addfavorite?id=" + id + "&companyId=" + companyId, ApiSuccess);
};

export const removeFolderFromFavorites = (id: string, companyId: string): Promise<ApiSuccess> => {
    return postApiCall("api/document/removefavorite?id=" + id + "&companyId=" + companyId, ApiSuccess);
};

export const removeFile = (id: string, companyId: string): Promise<ApiSuccess> => {
    return postApiCall("api/document/removefile?id=" + id + "&companyId=" + companyId, ApiSuccess);
};

export const getDocumentView = (id: string, companyId: string): Promise<DocumentView> => {
    return getApiCall("api/document/version?id=" + id + "&companyId=" + companyId, DocumentView);
};